export default "__VITE_ASSET__pNRTQP8v__"